export default import.meta.ROLLDOWN_FILE_URL_UvD23WFwbRsl9Qin79zTzw